
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component({
  name: 'detail'
})
export default class Detail extends Vue {
  get createTime () {
    return this.data.createTime ? dayjs(this.data.createTime).format('YYYY-MM-DD HH:mm') : ''
  }

  get rightName () {
    return this.data.right ? this.data.right.rightName : ''
  }

  get userName () {
    return this.data.user ? this.data.user.userName : ''
  }

  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: Object })
  private data!: object|any
}
